import React, { useMemo } from 'react';
import T from 'prop-types';

import SimpleDropdown from '../../../../components/Dropdowns/SimpleDropdown';

const SdkFunctionsDropdown = ({ active = 'all', size, onChange }) => {
  const functionsOptions = useMemo(
    () => [
      { label: 'All Functions', value: 'all' },
      ...Object.keys(SDK_FUNCTIONS).map((key) => ({
        label: SDK_FUNCTIONS[key],
        value: key,
      })),
    ],
    []
  );

  const activeFunction = useMemo(
    () => functionsOptions.find(({ value }) => value === active || value.toLowerCase() === active),
    [active]
  );

  return (
    <SimpleDropdown
      selected={activeFunction.value}
      options={functionsOptions}
      size={size}
      menuWidth={212}
      menuAlign="start"
      position="initial"
      menuDirection="bottom"
      onChange={(value) => onChange(value, activeFunction.label)}
    />
  );
};

SdkFunctionsDropdown.propTypes = {
  active: T.string.isRequired,
  size: T.string,
  onChange: T.func.isRequired,
};

export default SdkFunctionsDropdown;
